import ReactGA from 'react-ga';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';

import { endpoints } from 'global/endpoints';
import { routePaths } from 'global/routePaths';
import { useUserStore } from 'store/useUserStore';
import http from 'utils/http';
import toaster from 'utils/toaster';
import token from 'utils/token';

export const registerUser = (postData: any) => {
  return http().post(endpoints.register, postData);
};

export function useRegister() {
  const history = useHistory();
  const addUserDetails = useUserStore(state => state.addUserDetails);

  return useMutation(registerUser, {
    onSuccess: ({ payload }: any) => {
      if (payload?.apiToken && payload?.userUniqueToken) {
        toaster.success({ description: 'Thanks! your account has been successfully created' });
        const { apiToken, userUniqueToken, apiTokenExpiresAt, ...userData } = payload;
        token.setToken({ accessToken: apiToken, userUniqueToken: userUniqueToken, expiryDate: apiTokenExpiresAt });
        addUserDetails(userData);

        ReactGA.ga('event', 'conversion', { send_to: 'AW-10828039579/XbQuCOTwpZIDEJuLm6so' });

        history.push(routePaths.thankYou);
      } else {
        toaster.error({ description: 'Something went wrong, please try again later.' });
      }
    },
  });
}
